/* eslint-disable */
define(function (require, exports, module) {
    var $ = require('jquery'),
        avalon = require('avalon'),
        tool = require('toolLoaderPC'),
        ajax = require('ajax'),
        pagination = require('pagination'),
        hiddenValues = null,
        localHiddensGlobal,
        pages,
        urlParam,
        vmodel = avalon.define({
            $id: 'searchController',

            list: [],
            recoList: [],
            isAjaxGetData: false,
            consultPagination: pagination.init(0, 0, 0),
            brand: [],
            searchByMoney: [],
            filterMin: '',
            filterMax: '',
            state: '',
            keywords: $('#keywords') ? $('#keywords').val() : '',
            consultGoPage: function (page) {
                if (page.disable) {
                    return;
                }
                var urlParams = tool.getUrlParams();
                urlParams.page = page.target;
                var url = tool.addParamToUrl('', urlParams);
                ajax.pjax(url);
            },

            sendEventTracking: function (n) {
                // console.log(n)
                tool.sendEventTracking('pc', n);
            },

            toTopVisible: true,
            toTopPositionBottom: 335,
            toTop: function () {
                tool.scrollTo($('#header'));
            },
            rendered: function () {
                $('img[data-original]').lazyload({
                    effect: 'fadeIn',
                    placeholder:
                        localHiddensGlobal.frontUrl +
                        'dest/shangou/images/placeholder.jpg',
                    threshold: 300,
                });
            },
            getPanicPrice: function (el) {
                var price =
                    tool.toNumber(el.min_price) -
                    tool.toNumber(el.panic_discount);
                price = price <= 0 ? 0 : price;
                price = tool.toMoney(price);
                return Number(price);
            },
            filterSelect: function (type, index) {
                if (vmodel[type][index].selected) {
                    vmodel[type][index].selected = false;
                } else {
                    vmodel[type].forEach(function (e) {
                        e.selected = false;
                    });
                    vmodel[type][index].selected = true;
                }
                if (type === 'searchByMoney') {
                    vmodel.filterMax = '';
                    vmodel.filterMin = '';
                }
            },
            filterConfirm: function () {
                var min, max;
                max = vmodel.filterMax;
                min = vmodel.filterMin;
                var brand = vmodel.brand.filter(function (el) {
                    return el.selected;
                })[0];
                var minMax = vmodel.searchByMoney.filter(function (el) {
                    return el.selected;
                })[0];
                if (minMax) {
                    min = minMax.min;
                    max = minMax.max;
                }
                vmodel.list = [];
                var urlParams = tool.getUrlParams();
                if (min) {
                    urlParams.min = min;
                } else {
                    delete urlParams.min;
                }
                if (max) {
                    urlParams.max = max || '';
                } else {
                    delete urlParams.max;
                }
                urlParams.brand_id = brand && brand.id;
                var url = tool.addParamToUrl(
                    window.location.host + window.location.pathname,
                    urlParams,
                );
                vmodel.state = 'pending';
                ajax.pjax(tool.addParamToUrl('', delUndefined(urlParams)));
            },
            filterReset: function () {
                window.jump();
            },
            onMoneyInput: function () {
                var max = vmodel.filterMax;
                var min = vmodel.filterMin;
                if (isNaN(min) || min < 0) vmodel.filterMin = 0;
                if (isNaN(max)) vmodel.filterMax = 0;
                if (min > 10000) vmodel.filterMin = 10000;
                if (max > 10000) vmodel.filterMax = 10000;
                addProp(vmodel.searchByMoney, 'selected', false);
            },
            sortByPrice: '', //价格排序类型 up 升序， down 降序
            sortBySell: '', //销量排序类型 up 升序， down 降序
            sortByReco: '', //推荐排序类型 up 升序， down 降序
            SORT_WAY: ['price', 'sell', 'reco'],
            sortClick: function (type) {
                vmodel.SORT_WAY.forEach(function (el) {
                    var sort_way_key =
                        'sortBy' + el[0].toUpperCase() + el.slice(1);
                    if (type !== el) {
                        vmodel[sort_way_key] = '';
                    }
                });
                var urlParams = tool.getUrlParams();
                var sort_type = urlParams.sort_type;
                if (sort_type == 'down') {
                    urlParams.sort_type = 'up';
                } else if (sort_type === 'up') {
                    urlParams.sort_type = 'down';
                } else {
                    urlParams.sort_type = 'down';
                }
                urlParams.sort_way = type;
                var url = tool.addParamToUrl('', urlParams);
                // location.href = location.protocol + '//' + url
                ajax.pjax(url);
            },
        });

    window.vm = vmodel;
    return {
        init: function () {
            hiddenValues = tool.getHiddenValues('#js-local-hiddens');
            var brandSelected = vmodel.brand.filter(function (el) {
                return el.selected;
            });
            var searchByMoneySelected = vmodel.searchByMoney.filter(function (
                el,
            ) {
                return el.selected;
            });
            vmodel.recoList = hiddenValues.searchRecommend || [];
            if (!brandSelected.length && !searchByMoneySelected.length) {
                vmodel.searchByMoney = addProp(
                    hiddenValues.searchByMoney,
                    'selected',
                    false,
                );
                vmodel.brand = addProp(hiddenValues.brand, 'selected', false);
            }

            // 从url参数获取搜索条件
            readFromUrl();

            localHiddensGlobal = tool.getHiddenValues('#js-hiddens');

            var goodsList = hiddenValues.goods_list.data || [];
            for (var i = 0; i < goodsList.length; i++) {
                goodsList[i].sell_total = null;
                goodsList[i].sku_total = null;
            }
            vmodel.list = goodsList;

            pages = hiddenValues.goods_list.pages;
            urlParam = hiddenValues.url_param;
            window.hiddenValues = hiddenValues;
            console.log(pages);
            vmodel.consultPagination = pagination.init(
                pages.total,
                pages.curpage,
                pages.pageSize,
            );
            console.log(vmodel.consultPagination);

            tool.onWindowScroll.on(function (e, top) {
                if (top === 0) {
                    vmodel.toTopVisible = false;
                } else {
                    vmodel.toTopVisible = true;
                }

                var clientHeight = tool.getClientHeight(),
                    scrollHeight = tool.getScrollHeight();

                if (scrollHeight - clientHeight - top < 335) {
                    vmodel.toTopPositionBottom =
                        335 - (scrollHeight - clientHeight - top);
                } else {
                    vmodel.toTopPositionBottom = 20;
                }
            });

            //动态获取销量数据
            var multiId = [];
            for (var i = 0; i < goodsList.length; i++) {
                multiId.push(goodsList[i].id);
            }
            if (multiId.length) {
                ajax
                    .postWithFail('/goods/default/goods-sale.html', {
                        multi_id: multiId.join(','),
                    })
                    .done(function (response) {
                        for (var i = 0; i < goodsList.length; i++) {
                            vmodel.list[i].sell_total =
                                response.msg[goodsList[i].id].sell_total;
                            vmodel.list[i].sku_total =
                                response.msg[goodsList[i].id].sku_total;
                        }
                        vmodel.isAjaxGetData = true;
                    });
            }

            vmodel.sendEventTracking(10100);

            // 更改标题
            if (/search\.html/.test(location.href)) {
                $('title').text('搜索-爱羽客正品羽毛球装备购物商城');
            }

            $(document).on('pjax:complete', function () {
                // 重新初始化导航栏
                window.navInit && window.navInit();
                // 更新搜索关键字
                vmodel.keywords = $('#keywords') ? $('#keywords').val() : '';
                // 根据url参数显示隐藏搜索条件
                var urlParams = tool.getUrlParams();
                if (!urlParams['brand_id']) {
                    addProp(vmodel.brand, 'selected', false);
                }
                if (!urlParams['min']) {
                    addProp(vmodel.searchByMoney, 'selected', false);
                }
                if (!urlParams['sort_way']) {
                    ['sortByPrice', 'sortBySell', 'sortByReco'].forEach(
                        function (el) {
                            vmodel[el] = '';
                        },
                    );
                }

                vmodel.state = '';
            });
        },
        clear: function () { },
    };

    function addProp(arr, prop, val) {
        return arr.map(function (el) {
            // if (!el[prop]) {
            el[prop] = val;
            // }
            return el;
        });
    }

    function delUndefined(obj) {
        for (var p in obj) {
            if (typeof obj[p] === 'undefined') {
                delete obj[p];
            }
        }
        return obj;
    }

    function readFromUrl() {
        var urlParams = tool.getUrlParams();
        if (urlParams.sort_way) {
            var sort_way_key =
                'sortBy' +
                urlParams.sort_way[0].toUpperCase() +
                urlParams.sort_way.slice(1);
            vmodel[sort_way_key] = urlParams.sort_type || 'down';
        }
        if (urlParams.brand_id) {
            vmodel.brand.forEach(function (el, i) {
                if (urlParams.brand_id === el.id) {
                    el.selected = true;
                }
            });
        }
        var isSearchByMoneyLabel;
        vmodel.searchByMoney.forEach(function (el, i) {
            if (
                (urlParams.min == el.min && urlParams.max == el.max) ||
                (urlParams.min == el.min && !urlParams.max) ||
                (urlParams.max == el.max && !urlParams.min)
            ) {
                el.selected = true;
                isSearchByMoneyLabel = true;
            }
        });
        if (!isSearchByMoneyLabel) {
            vmodel.filterMin = urlParams.min || '';
            vmodel.filterMax = urlParams.max || '';
        } else {
            vmodel.filterMin = '';
            vmodel.filterMax = '';
        }
    }
});



// WEBPACK FOOTER //
// ./src/js_modules/searchController.js